import { render, staticRenderFns } from "./Example.vue?vue&type=template&id=d3db3fd4"
import script from "./Example.vue?vue&type=script&lang=js"
export * from "./Example.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports